import { TruncatableText } from '@routable/components';
import React from 'react';
import { Icon } from 'components';
import { margin, sizes } from 'constants/styles';
import {} from './PartnerPaymentMethodStatusContentLeft.types';
const PartnerPaymentMethodStatusContentLeft = ({ statusIcon, statusText, }) => (React.createElement(React.Fragment, null,
    statusIcon && (React.createElement(Icon, { className: "min-w-[14px]", icon: statusIcon, marginRight: margin.extraMedium, size: sizes.iconSizes.LARGE, title: "Status icon" })),
    React.createElement(TruncatableText, { className: "font-semibold text-grey-70 text-xs", dataFullStory: true, position: "top", text: statusText })));
export default PartnerPaymentMethodStatusContentLeft;
